class BESSAppProjectWaterSpaceEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.updating = false;
        this.#updateConnectedToRWTankInput();
    }


    updateState() {
        if (this.updating) {
            return;
        }
        this.updating = true;
        super.updateState();
        this.#updateConnectedToRWTankInput();
        this._forEachItem(this.manageItem.bind(this));
        this.updating = false;
    }

    #updateConnectedToRWTankInput() {
        let connectedToWhichTankField = this.editor.data.getFieldForAttribute('connectedToWhichTank');
        let hasValidChoices = connectedToWhichTankField.choices.length > 1;
        this.editor.node.find('.app-editor-field-connectedToWhichTank').showIf(hasValidChoices);
    }


    manageItem(item) {
        super.manageItem(item);
        this.updateValidHotWaterSelections(item);
    }

    updateValidHotWaterSelections(item) {
        let rainwaterConnectedToHotWaterSystem = item.inputs.rainwaterConnectedToHotWaterSystem;
        let connectedToWhichTank = item.inputs.connectedToWhichTank;
        let tankSelect = connectedToWhichTank.getValue(null);
        if (tankSelect != null) {
            var tankSelectVal = null;
            if(_.has(tankSelect, 'key')) {
                tankSelectVal = parseInt(tankSelect.key);
            } else {
                tankSelectVal = parseInt(tankSelect);
            }
            if(tankSelectVal == undefined) {
                return;
            }
            let isRecycled = connectedToWhichTank.field.extra['is-recycled-' + tankSelectVal];
            rainwaterConnectedToHotWaterSystem.inputYes.attr('disabled', isRecycled);
            if (isRecycled && rainwaterConnectedToHotWaterSystem.getValue() == null || rainwaterConnectedToHotWaterSystem.getValue()) {
                rainwaterConnectedToHotWaterSystem.setValue(false);
            }
        }
    }
}